module.exports = __webpack_public_path__ + "img/Reverso.11b65a43.jpg";